const manageEmailForm = {
    namespaced: true,
    state: {
        isEmailFormVisible: false,
        documentType: null,
        documentId: null,
        emailIsSending: false
    },
    mutations: {
        updateEmailIsSendingmState(state, value) {
            state.emailIsSending = value;
        },
        updateEmailFormState(state, value) {
            state.isEmailFormVisible = value;
        },
        updateDocumentTypeState(state, value) {
            state.documentType = value;
        },
        updateDocumentIdState(state, value) {
            state.documentId = value;
        },
    },
    actions: {
        updateEmailIsSending: function({ commit }, value) {
            commit('updateEmailIsSendingmState', value)
        },
        updateIsEmailFormVisible: function({ commit }, value) {
            commit('updateEmailFormState', value)
        },
        setDocumentType: function({ commit }, value) {
            commit('updateDocumentTypeState', value)
        },
        setDocumentId: function({ commit }, value) {
            commit('updateDocumentIdState', value)
        },
    }
}

export default manageEmailForm;